module.exports = __webpack_public_path__ + "static/img/Logo_SOIL-DE.3c2686d9.png";